import { Modal } from 'components/Modal';
import { Title } from 'components/Title';
import React, { FC } from 'react';
import styles from './OrderHistory.module.scss';

interface HistoryItem {
  datetime: string;
  text: string;
}

interface GroupedHistory {
  datetime: string;
  items: Array<{
    date: string;
    text: string;
  }>;
}

interface OrderHistoryProps {
  history?: HistoryItem[];
  onClose: () => void;
}

export const OrderHistory: FC<OrderHistoryProps> = ({ history = [], onClose }) => {
  const groupedHistory = React.useMemo(() => {
    const groups: Record<string, GroupedHistory> = {};

    history.forEach((elem) => {
      const { datetime, ...rest } = elem;
      const dateSlice = datetime.split(' ').slice(0, 2).join(' ');

      if (!groups[dateSlice]) {
        groups[dateSlice] = {
          datetime: dateSlice,
          items: [],
        };
      }

      groups[dateSlice].items.push({
        date: datetime.split(' ').slice(2).join(''),
        ...rest,
      });
    });

    return Object.values(groups);
  }, [history]);

  return (
    <Modal open={true} setOpen={onClose}>
      <div className={styles.root_block}>
        <Title className={styles.root_history_title} title='История заказа' />
        {groupedHistory.map((group, groupIndex) => (
          <div key={groupIndex}>
            <p className={styles.root_date}>{group.datetime}</p>
            {group.items.map((item, itemIndex) => (
              <div className={styles.root_block_text} key={itemIndex}>
                <div className={styles.root_text}>
                  <Title
                    style={{
                      fontWeight: 400,
                      fontSize: '16px',
                      lineHeight: '24px',
                    }}
                    title={item.text}
                  />
                  <p className={styles.root_datetext}>{item.date}</p>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </Modal>
  );
};
